import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
import Person from "@material-ui/icons/Person";
import Button from "../../Components/CustomButtons/Button.js";
import styles from "../../assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import { useHistory } from 'react-router-dom';
import { Notifications } from "@material-ui/icons";
import { connect, useSelector } from "react-redux";
import { PageStatus } from "../../enums";
import { AuthAPI, NewsLetterAPI } from "../../API";
import { menuDict } from "Languages/ProfileTranslations.js";
import LanguageToggle from "../Common/LanguageToggle";
import PropTypes from "prop-types";

const useStyles = makeStyles(styles);

function AdminNavbarLinks(props) {
  const history = useHistory();
  const classes = useStyles();
  const [openNotification, setOpenNotification] = React.useState(null);
  const [openProfile, setOpenProfile] = React.useState(null);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(PageStatus.None);
  const [errors, setErrors] = useState('');
  const lang = props.language ?? 'en';
  const { userId, role } = useSelector((state) => state.adminUser.adminUser);
  const [totalCount, setTotalCount] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      Promise.resolve()
        .then(() => setStatus(PageStatus.Loading))
        .then(() => AuthAPI.userNotifications(userId))
        .then((response) => {
          if (response) {
            setData(response)
            setStatus(PageStatus.Loaded)
          }
        })
        .catch((error) => {
          console.log("status = ", status);
          console.log("error = ", errors);
          setStatus(PageStatus.Error)
          setErrors(error.message)
        });
    };


    // Fetch inbox details (total count)
    const appInboxDetails = async () => {
      try {
        const response = await NewsLetterAPI.appInbox(userId);
        const unread = response?.data?.totalcountunread ?? response?.totalcountunread ?? 0;
        setTotalCount(unread);
      } catch (error) {
        console.error("Error fetching inbox details:", error);
      }
    };
    appInboxDetails();
    fetchData();
  }, [userId]);

  const handleNotificationClick = (event) => {
    if (role === 'panelist') {
      setTotalCount(0);
      history.push("/panelist/Notifications");
    } else {
      if (openNotification?.contains(event.target)) {
        setOpenNotification(null);
      } else {
        setOpenNotification(event.currentTarget);
      }
    }
  };

  const handleCloseNotification = () => {
    setOpenNotification(null);
  };
  const handleClickProfile = (event) => {
    if (openProfile?.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };

  const handleCloseProfileMenu = () => {
    setOpenProfile(null);
  };

  const handleCloseProfile = () => {
    // Logout wipes localStorage (auth, tokens, session) but the language
    // preference is a UI setting, not auth state — preserve it across the
    // clear() so the post-logout login page stays in the chosen language.
    let savedLang = null;
    try { savedLang = localStorage.getItem('userLanguagePreference'); } catch (e) { /* storage unavailable — non-fatal */ }
    localStorage.clear();
    try { if (savedLang) { localStorage.setItem('userLanguagePreference', savedLang); } } catch (e) { /* storage unavailable — non-fatal */ }
    window.location.href = '/';
    setOpenProfile(null);
  };

  const handleClickSettings = () => {
    history.push('/panelist/settings')
    setOpenProfile(null);
  }

  const handleClickProfiles = () => {
    history.push('/panelist/profile-overview')
    setOpenProfile(null);
  }

  return (
    <div>
      <div className={classes.manager}>
        <div className="text-center">
          <LanguageToggle />
        </div>
      </div>
      <div className={classes.manager}>
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={(window.innerWidth <= 959)}
          aria-owns={openNotification ? "notification-menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleNotificationClick}
          className={classes.buttonLink}
        >
          <Notifications className={classes.icons} />
          {/* Display totalCount fetched from the API */}
          <span className={classes.notifications}>{totalCount > 0 ? totalCount : "0"}</span>
          <Hidden mdUp implementation="css">
            <span onClick={handleCloseNotification} className="bg-transparent text-white">
              <p className={classes.linkText}>
                {menuDict[lang]["Notification"] || "Notification"}
              </p>
            </span>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openNotification)}
          anchorEl={openNotification}
          transition
          disablePortal
          className={
            classNames({ [classes.popperClose]: !openNotification }) +
            " " +
            classes.popperNav
          }
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="notification-menu-list-grow"
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseNotification}>
                  <MenuList role="menu">
                    {data && data.length > 0 ? data.map((info, index) => (
                      <MenuItem
                        key={info.id}
                        onClick={handleCloseNotification}
                        className={classes.dropdownItem}
                      >
                        {info.message}
                      </MenuItem>
                    )) : (
                      <MenuItem
                        className={classes.dropdownItem}
                        style={{ opacity: 0.6, fontStyle: 'italic', justifyContent: 'center' }}
                        disabled
                      >
                        {menuDict[lang]["No notifications"] || "No notifications available"}
                      </MenuItem>
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
      <div className={classes.manager}>
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={(window.innerWidth <= 959)}
          aria-owns={openProfile ? "profile-menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}
        >
          <Person className={classes.icons} />
          <Hidden mdUp implementation="css">
            <p className={classes.linkText}>{menuDict[lang]["Profile"] || "Profile"}</p>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          className={
            classNames({ [classes.popperClose]: !openProfile }) +
            " " +
            classes.popperNav
          }
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list-grow"
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseProfileMenu}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={() => handleClickProfiles()}
                      className={classes.dropdownItem}
                    >
                      {menuDict[lang]["Profile"] || "Profile"}
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleClickSettings()}
                      className={classes.dropdownItem}
                    >
                      {menuDict[lang]["Settings"] || "Settings"}
                    </MenuItem>
                    <Divider light />
                    <MenuItem
                      onClick={() => handleCloseProfile()}
                      className={classes.dropdownItem}
                    >
                      {menuDict[lang]["Logout"] || "Logout"}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>

            </Grow>
          )}
        </Poppers>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userId: state.adminUser.adminUser.userId,
    role: state.adminUser.adminUser.role,
    language: state.adminUser.adminUser.language,
  };
}

AdminNavbarLinks.propTypes = {
  language: PropTypes.string,
}
export default connect(mapStateToProps, {})(AdminNavbarLinks);
